// import React, { useState, useEffect, useRef } from "react";
// import {
//   fetchUsers,
//   createUser,
//   updateUser
// } from "../services/adminService";
// import "./AdminUserView.css";
// import { fetchBrands } from "../services/brandService";

// function AdminUserView() {
//   const [users, setUsers] = useState([]);
//   const [brands, setBrands] = useState([]);
//   const [editingUserId, setEditingUserId] = useState(null);
//   const [editPhone, setEditPhone] = useState("");
//   const [savingPhone, setSavingPhone] = useState(false);
//   const [showForm, setShowForm] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [brandSearchTerm, setBrandSearchTerm] = useState("");
//   const [isBrandDropdownOpen, setIsBrandDropdownOpen] = useState(false);

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     password: "",
//     user_type: "business",
//     org_role: "BM",
//     brands: [],
//   });

//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     loadData();
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsBrandDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const loadData = async () => {
//   try {
//     const [uData, bData] = await Promise.all([
//       fetchUsers(),
//       fetchBrands()
//     ]);

//     console.log("========== ADMIN USER DEBUG ==========");
//     console.log("USERS FROM API:", uData);
//     console.log("USERS COUNT:", uData?.length);
//     console.log("BRANDS FROM API:", bData);
//     console.log("======================================");

//     setUsers(uData || []);
//     setBrands(bData || []);

//   } catch (err) {
//     console.error("ERROR LOADING ADMIN DATA:", err);
//   }
// };

//   const handleRoleChange = (e) => {
//     const selectedRole = e.target.value;
//     setFormData((prev) => ({
//       ...prev,
//       org_role: selectedRole,
//       brands: selectedRole === "BM" ? prev.brands : [],
//     }));
//   };

//   const handleBrandToggle = (brandId) => {
//     setFormData((prev) => {
//       const exists = prev.brands.includes(brandId);
//       return {
//         ...prev,
//         brands: exists
//           ? prev.brands.filter((b) => b !== brandId)
//           : [...prev.brands, brandId],
//       };
//     });
//   };

//   const handleSelectAllBrands = () => {
//     const allIds = brands.map((b) => b.id);
//     setFormData((prev) => ({ ...prev, brands: allIds }));
//   };

//   const handleClearAllBrands = () => {
//     setFormData((prev) => ({ ...prev, brands: [] }));
//   };

//   const handleSaveUser = async (e) => {
//     e.preventDefault();

//     try {
//       await createUser(formData);

//       setShowForm(false);
//       setFormData({
//         name: "",
//         email: "",
//         phone: "",
//         password: "",
//         user_type: "business",
//         org_role: "BM",
//         brands: [],
//       });

//       loadData();
//     } catch (err) {
//       console.error("CREATE USER ERROR:", err);
//       alert("Error saving user. Please try again.");
//     }
//   };

//   const filteredUsers = users.filter((u) => {
//     const query = searchTerm.toLowerCase();
//     return (
//       u.name?.toLowerCase().includes(query) ||
//       u.email?.toLowerCase().includes(query) ||
//       u.phone?.toLowerCase().includes(query) ||
//       u.org_role?.toLowerCase().includes(query)
//     );
//   });

//   const filteredBrands = brands.filter((b) =>
//     (b.brand_name || "")
//       .toLowerCase()
//       .includes(brandSearchTerm.toLowerCase())
//   );

//   const bmCount = users.filter((u) => u.org_role === "BM").length;
//   const adminCount = users.filter((u) => u.org_role === "ADMIN").length;

//   return (
//     <div className="admin-page-container">
//       <header className="admin-header">
//         <div>
//           <h1>Admin Workspace</h1>
//           <p className="admin-subtitle">
//             Manage system access, roles, and brand assignments
//           </p>
//         </div>
//       </header>

//       <div className="admin-stats-grid">
//         <div className="stat-card">
//           <h3>Total Users</h3>
//           <p>{users.length}</p>
//         </div>
//         <div className="stat-card">
//           <h3>Brands</h3>
//           <p>{brands.length}</p>
//         </div>
//         <div className="stat-card">
//           <h3>BM Users</h3>
//           <p>{bmCount}</p>
//         </div>
//         <div className="stat-card">
//           <h3>Admins</h3>
//           <p>{adminCount}</p>
//         </div>
//       </div>

//       <div className="admin-actions">
//         <h2>Users Directory</h2>
//         <div className="action-buttons-group">
//           <input
//             type="text"
//             className="search-input"
//             placeholder="Search users..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//           <button className="btn-create" onClick={() => setShowForm((prev) => !prev)}>
//             {showForm ? "Cancel" : "+ Create User"}
//           </button>
//         </div>
//       </div>

//       {showForm && (
//         <div className="inline-form-card">
//           <div className="form-card-header">
//             <h3>Create New User</h3>
//             <span className="form-card-sub">
//               Assign credentials and brand permissions
//             </span>
//           </div>

//           <form onSubmit={handleSaveUser} className="admin-inline-form">
//             <div className="form-grid">
//               <div className="form-group">
//                 <label>Full Name</label>
//                 <input
//                   required
//                   type="text"
//                   placeholder="e.g. Rahul Sharma"
//                   value={formData.name}
//                   onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Email Address</label>
//                 <input
//                   required
//                   type="email"
//                   placeholder="rahul@company.com"
//                   value={formData.email}
//                   onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Mobile Number</label>
//                 <input
//                   type="text"
//                   placeholder="9876543210"
//                   value={formData.phone}
//                   onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Password</label>
//                 <input
//                   required
//                   type="password"
//                   placeholder="••••••••••••"
//                   value={formData.password}
//                   onChange={(e) => setFormData({ ...formData, password: e.target.value })}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>User Role</label>
//                 <select value={formData.org_role} onChange={handleRoleChange}>
//                   <option value="BM">BM (Brand Manager)</option>
//                   <option value="ADMIN">ADMIN</option>
//                 </select>
//               </div>

//               {formData.org_role === "BM" && (
//                 <div className="form-group full-width" ref={dropdownRef}>
//                   <label>Assign Brands</label>
//                   <div className="custom-multiselect">
//                     <button
//                       type="button"
//                       className="multiselect-trigger"
//                       onClick={() => setIsBrandDropdownOpen((prev) => !prev)}
//                     >
//                       <span>
//                         {formData.brands.length === 0
//                           ? "Select Brands..."
//                           : `${formData.brands.length} Brand(s) Selected`}
//                       </span>
//                       <span className="dropdown-arrow">▼</span>
//                     </button>

//                     {isBrandDropdownOpen && (
//                       <div className="multiselect-menu">
//                         <div className="multiselect-search-header">
//                           <input
//                             type="text"
//                             className="brand-search-input"
//                             placeholder="Search brands..."
//                             value={brandSearchTerm}
//                             onChange={(e) => setBrandSearchTerm(e.target.value)}
//                           />
//                           <div className="multiselect-actions">
//                             <button
//                               type="button"
//                               className="btn-text-action"
//                               onClick={handleSelectAllBrands}
//                             >
//                               Select All
//                             </button>
//                             <button
//                               type="button"
//                               className="btn-text-action"
//                               onClick={handleClearAllBrands}
//                             >
//                               Clear
//                             </button>
//                           </div>
//                         </div>

//                         <div className="multiselect-list">
//                           {filteredBrands.length === 0 ? (
//                             <div className="multiselect-empty">No brands found</div>
//                           ) : (
//                             filteredBrands.map((b) => (
//                               <label key={b.id} className="multiselect-item">
//                                 <input
//                                   type="checkbox"
//                                   checked={formData.brands.includes(b.id)}
//                                   onChange={() => handleBrandToggle(b.id)}
//                                 />
//                                 <span>{b.brand_name}</span>
//                               </label>
//                             ))
//                           )}
//                         </div>

//                         <div className="multiselect-footer">
//                           <button
//                             type="button"
//                             className="btn-apply"
//                             onClick={() => setIsBrandDropdownOpen(false)}
//                           >
//                             Apply Selection
//                           </button>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="form-footer-actions">
//               <button
//                 type="button"
//                 className="btn-cancel"
//                 onClick={() => setShowForm(false)}
//               >
//                 Cancel
//               </button>
//               <button type="submit" className="btn-save">
//                 Save User
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       <table className="admin-table">
//         <thead>
//           <tr>
//             <th>Name</th>
//             <th>Email</th>
//             <th>Mobile</th>
//             <th>Role</th>
//             <th>Assigned Brands</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredUsers.length === 0 ? (
//             <tr>
//               <td colSpan="5" className="table-empty">
//                 No users match your criteria.
//               </td>
//             </tr>
//           ) : (
//             filteredUsers.map((u) => (
//               <tr key={u.id}>
//                 <td className="font-medium">{u.name}</td>
//                 <td>{u.email}</td>
//                 <td>{u.phone || "-"}</td>
//                 <td>
//                   <span className={`role-badge role-${(u.org_role || "").toLowerCase()}`}>
//                     {u.org_role}
//                   </span>
//                 </td>
//                 <td>
//                   {Array.isArray(u.brands) ? u.brands.join(", ") : u.brands || "None"}
//                 </td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// }

// export default AdminUserView; 

import React, { useState, useEffect, useRef } from "react";
import {
  fetchUsers,
  createUser,
  updateUser
} from "../services/adminService";
import "./AdminUserView.css";
import { fetchBrands } from "../services/brandService";

function AdminUserView() {
  const [users, setUsers] = useState([]);
  const [brands, setBrands] = useState([]);

  // Form display and edit state
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [savingUser, setSavingUser] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [brandSearchTerm, setBrandSearchTerm] = useState("");
  const [isBrandDropdownOpen, setIsBrandDropdownOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    user_type: "business",
    org_role: "BM",
    brands: [],
  });

  const dropdownRef = useRef(null);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsBrandDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const loadData = async () => {
    try {
      const [uData, bData] = await Promise.all([
        fetchUsers(),
        fetchBrands()
      ]);

      console.log("========== ADMIN USER DEBUG ==========");
      console.log("USERS FROM API:", uData);
      console.log("USERS COUNT:", uData?.length);
      console.log("BRANDS FROM API:", bData);
      console.log("======================================");

      setUsers(uData || []);
      setBrands(bData || []);

    } catch (err) {
      console.error("ERROR LOADING ADMIN DATA:", err);
    }
  };

  const handleRoleChange = (e) => {
    const selectedRole = e.target.value;
    setFormData((prev) => ({
      ...prev,
      org_role: selectedRole,
      brands: selectedRole === "BM" ? prev.brands : [],
    }));
  };

  const handleBrandToggle = (brandId) => {
    setFormData((prev) => {
      const exists = prev.brands.includes(brandId);
      return {
        ...prev,
        brands: exists
          ? prev.brands.filter((b) => b !== brandId)
          : [...prev.brands, brandId],
      };
    });
  };

  const handleSelectAllBrands = () => {
    const allIds = brands.map((b) => b.id);
    setFormData((prev) => ({ ...prev, brands: allIds }));
  };

  const handleClearAllBrands = () => {
    setFormData((prev) => ({ ...prev, brands: [] }));
  };

  const handleEditUser = (user) => {
    setEditingUser(user);

    setFormData({
      name: user.name || "",
      email: user.email || "",
      phone: user.phone || "",
      password: "",
      user_type: user.user_type || "business",
      org_role: user.org_role || "BM",
      brands: user.brand_ids || [],
    });

    setShowForm(true);
  };

  const handleSaveUser = async (e) => {
    e.preventDefault();

    try {
      setSavingUser(true);

      if (editingUser) {
        // UPDATE EXISTING USER
        const updateData = {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          user_type: formData.user_type,
          org_role: formData.org_role,
          brands: formData.brands,
        };

        // Only send password if user entered a new one
        if (formData.password.trim() !== "") {
          updateData.password = formData.password;
        }

        await updateUser(editingUser.id, updateData);

        alert("User updated successfully.");

      } else {
        // CREATE NEW USER
        await createUser(formData);

        alert("User created successfully.");
      }

      setShowForm(false);
      setEditingUser(null);

      setFormData({
        name: "",
        email: "",
        phone: "",
        password: "",
        user_type: "business",
        org_role: "BM",
        brands: [],
      });

      await loadData();

    } catch (err) {
      console.error("SAVE USER ERROR:", err);
      alert(
        editingUser
          ? "Error updating user. Please try again."
          : "Error creating user. Please try again."
      );
    } finally {
      setSavingUser(false);
    }
  };

  const filteredUsers = users.filter((u) => {
    const query = searchTerm.toLowerCase();
    return (
      u.name?.toLowerCase().includes(query) ||
      u.email?.toLowerCase().includes(query) ||
      u.phone?.toLowerCase().includes(query) ||
      u.org_role?.toLowerCase().includes(query)
    );
  });

  const filteredBrands = brands.filter((b) =>
    (b.brand_name || "")
      .toLowerCase()
      .includes(brandSearchTerm.toLowerCase())
  );

  const bmCount = users.filter((u) => u.org_role === "BM").length;
  const adminCount = users.filter((u) => u.org_role === "ADMIN").length;

  return (
    <div className="admin-page-container">
      <header className="admin-header">
        <div>
          <h1>Admin Workspace</h1>
          <p className="admin-subtitle">
            Manage system access, roles, and brand assignments
          </p>
        </div>
      </header>

      <div className="admin-stats-grid">
        <div className="stat-card">
          <h3>Total Users</h3>
          <p>{users.length}</p>
        </div>
        <div className="stat-card">
          <h3>Brands</h3>
          <p>{brands.length}</p>
        </div>
        <div className="stat-card">
          <h3>BM Users</h3>
          <p>{bmCount}</p>
        </div>
        <div className="stat-card">
          <h3>Admins</h3>
          <p>{adminCount}</p>
        </div>
      </div>

      <div className="admin-actions">
        <h2>Users Directory</h2>
        <div className="action-buttons-group">
          <input
            type="text"
            className="search-input"
            placeholder="Search users..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            className="btn-create"
            onClick={() => {
              setEditingUser(null);

              setFormData({
                name: "",
                email: "",
                phone: "",
                password: "",
                user_type: "business",
                org_role: "BM",
                brands: [],
              });

              setShowForm(true);
            }}
          >
            + Create User
          </button>
        </div>
      </div>

      {showForm && (
        <div className="inline-form-card">
          <div className="form-card-header">
            <h3>{editingUser ? "Edit User" : "Create New User"}</h3>
            <span className="form-card-sub">
              {editingUser
                ? "Update user details and brand permissions"
                : "Assign credentials and brand permissions"}
            </span>
          </div>

          <form onSubmit={handleSaveUser} className="admin-inline-form">
            <div className="form-grid">
              <div className="form-group">
                <label>Full Name</label>
                <input
                  required
                  type="text"
                  placeholder="e.g. Rahul Sharma"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label>Email Address</label>
                <input
                  required
                  type="email"
                  placeholder="rahul@company.com"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label>Mobile Number</label>
                <input
                  type="text"
                  placeholder="9876543210"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label>
                  Password {editingUser ? "(leave blank to keep current password)" : ""}
                </label>
                <input
                  required={!editingUser}
                  type="password"
                  placeholder={
                    editingUser
                      ? "Leave blank to keep current password"
                      : "••••••••••••"
                  }
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      password: e.target.value
                    })
                  }
                />
              </div>

              <div className="form-group">
                <label>User Role</label>
                <select value={formData.org_role} onChange={handleRoleChange}>
                  <option value="BM">BM (Brand Manager)</option>
                  <option value="ADMIN">ADMIN</option>
                </select>
              </div>

              {formData.org_role === "BM" && (
                <div className="form-group full-width" ref={dropdownRef}>
                  <label>Assign Brands</label>
                  <div className="custom-multiselect">
                    <button
                      type="button"
                      className="multiselect-trigger"
                      onClick={() => setIsBrandDropdownOpen((prev) => !prev)}
                    >
                      <span>
                        {formData.brands.length === 0
                          ? "Select Brands..."
                          : `${formData.brands.length} Brand(s) Selected`}
                      </span>
                      <span className="dropdown-arrow">▼</span>
                    </button>

                    {isBrandDropdownOpen && (
                      <div className="multiselect-menu">
                        <div className="multiselect-search-header">
                          <input
                            type="text"
                            className="brand-search-input"
                            placeholder="Search brands..."
                            value={brandSearchTerm}
                            onChange={(e) => setBrandSearchTerm(e.target.value)}
                          />
                          <div className="multiselect-actions">
                            <button
                              type="button"
                              className="btn-text-action"
                              onClick={handleSelectAllBrands}
                            >
                              Select All
                            </button>
                            <button
                              type="button"
                              className="btn-text-action"
                              onClick={handleClearAllBrands}
                            >
                              Clear
                            </button>
                          </div>
                        </div>

                        <div className="multiselect-list">
                          {filteredBrands.length === 0 ? (
                            <div className="multiselect-empty">No brands found</div>
                          ) : (
                            filteredBrands.map((b) => (
                              <label key={b.id} className="multiselect-item">
                                <input
                                  type="checkbox"
                                  checked={formData.brands.includes(b.id)}
                                  onChange={() => handleBrandToggle(b.id)}
                                />
                                <span>{b.brand_name}</span>
                              </label>
                            ))
                          )}
                        </div>

                        <div className="multiselect-footer">
                          <button
                            type="button"
                            className="btn-apply"
                            onClick={() => setIsBrandDropdownOpen(false)}
                          >
                            Apply Selection
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="form-footer-actions">
              <button
                type="button"
                className="btn-cancel"
                onClick={() => {
                  setShowForm(false);
                  setEditingUser(null);
                  setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    password: "",
                    user_type: "business",
                    org_role: "BM",
                    brands: [],
                  });
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn-save"
                disabled={savingUser}
              >
                {savingUser
                  ? "Saving..."
                  : editingUser
                    ? "Update User"
                    : "Save User"}
              </button>
            </div>
          </form>
        </div>
      )}

      <table className="admin-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Role</th>
            <th>Assigned Brands</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.length === 0 ? (
            <tr>
              <td colSpan="6" className="table-empty">
                No users match your criteria.
              </td>
            </tr>
          ) : (
            filteredUsers.map((u) => (
              <tr key={u.id}>
                <td className="font-medium">{u.name}</td>
                <td>{u.email}</td>
                <td>{u.phone || "-"}</td>
                <td>
                  <span className={`role-badge role-${(u.org_role || "").toLowerCase()}`}>
                    {u.org_role}
                  </span>
                </td>
                <td>
                  {Array.isArray(u.brands) ? u.brands.join(", ") : u.brands || "None"}
                </td>
                <td>
                  <button
                    type="button"
                    className="btn-edit-user"
                    onClick={() => handleEditUser(u)}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default AdminUserView;